<template>
  <div>
    <div class="filter-dialog" :class="{ selected: selected }" @click="onClick">
      <img src="@/assets/filter.svg" alt="congestion" />
    </div>
    <div v-show="isDialogOpen" class="background" @click="onClose"></div>
    <div v-show="isDialogOpen" class="dialog">
      <p class="description">
        個人属性の希望の距離に応じたおすすめ観光スポットの表示
      </p>
      <hr />
      <p class="title">パーソナライズ</p>
      <ul class="list">
        <li
          v-for="item in tagList"
          :key="item.text"
          @click="onClickTag(item.id)"
          class="button"
          :class="{ selected: tmpSelectedFilter.tag.includes(item.id) }"
        >
          {{ item.text }}
        </li>
      </ul>
      <hr />
      <p class="title">スポットの距離</p>
      <ul class="list">
        <li
          v-for="item in distanceList"
          :key="item.text"
          @click="onClickDistance(item.distance)"
          class="button"
          :class="{
            selected: item.distance === tmpSelectedFilter.distance,
          }"
        >
          {{ item.text }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import DropSpotItem from "@/components/Organisms/DropSpotItem";
import { PARSONALIZE_TAG_LIST, FILTER_DISTANCE_LIST } from "../../const.js";

export default {
  name: "congestion-status-dialog",
  components: {
    ButtonTextLink,
    DropSpotItem,
  },
  props: {
    selected: { type: Boolean, default: false, required: true },
    current: { type: String, default: false, required: true },
  },
  data() {
    return {
      isDialogOpen: false,
      tmpSelectedFilter: {
        tag: [],
        distance: undefined,
      },
    };
  },
  computed: {
    ...mapState(["selectedFilter"]),
    tagList() {
      return PARSONALIZE_TAG_LIST;
    },
    distanceList() {
      return FILTER_DISTANCE_LIST;
    },
    currentSelectedFilter() {
      if (this.current === "RouteSearch") {
        return this.selectedFilter.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedFilter.jyutai;
      }
    },
  },
  methods: {
    ...mapMutations(["setSelectedFilter"]),
    onClick() {
      this.isDialogOpen = true;
      this.tmpSelectedFilter = {
        tag: this.currentSelectedFilter.tag,
        distance: this.currentSelectedFilter.distance,
      };
    },
    onClose() {
      this.isDialogOpen = false;
      this.setSelectedFilter(this.tmpSelectedFilter);
    },
    onClickTag(id) {
      // 複数選択可能
      const currentTagList = this.currentSelectedFilter.tag;

      currentTagList.filter((item) => item === id).length === 0
        ? currentTagList.push(id)
        : currentTagList.splice(currentTagList.indexOf(id), 1);

      const param = {
        tag: currentTagList,
        distance: this.tmpSelectedFilter.distance,
      };
      this.tmpSelectedFilter = param;
    },
    onClickDistance(distance) {
      let param = {
        tag: this.tmpSelectedFilter.tag,
        distance: distance,
      };

      if (this.tmpSelectedFilter.distance === distance) {
        param = {
          tag: this.tmpSelectedFilter.tag,
          distance: undefined,
        };
      }
      this.tmpSelectedFilter = param;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.filter-dialog {
  text-align: center;
  border-radius: 4px;
  padding-top: 2px 0;
  width: 32px;
  height: 32px;
  position: absolute;
  right: 0.25rem;
  bottom: 6rem;
  background: white;
  &.selected {
    bottom: 11.5rem;
  }
  img {
    height: 30px;
    width: 30px;
  }
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: calc(100% - 2rem * 2);
  overflow-y: scroll;
  padding: 1rem;
  border-radius: 12px;

  .description {
    font-size: 0.7rem;
    margin-bottom: 0.5rem;
    text-align: center;
  }
  .title {
    font-weight: 700;
    text-align: center;
  }
  .list {
    list-style: none;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
    .button {
      background: #e7e7e7;
      border-radius: 24px;
      text-align: center;
      padding: 0.25rem 0;

      &.selected {
        color: white;
        background: #5cd5d6;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelect/FilterDialog.vue